import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/public-site/app/exhibits/ExhibitsClient.tsx");
